"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Settings = exports.SettingsComponent = void 0;
var react_1 = __importStar(require("react"));
var PasswordSetting_1 = __importDefault(require("@features/SettingsPage/components/PasswordSetting"));
var ApiIntegration_1 = __importDefault(require("@features/SettingsPage/components/ApiIntegration"));
var LeftMenu_1 = require("src/react-app/features/SettingsPage/components/LeftMenu");
var TeamGeneralSetting_1 = __importDefault(require("@features/SettingsPage/components/TeamGeneralSetting"));
var TeamMembersSetting_1 = __importDefault(require("@features/SettingsPage/components/TeamMembersSetting"));
var ModerationSetting_1 = __importDefault(require("@features/SettingsPage/components/ModerationSetting"));
var Orchestration_1 = __importDefault(require("@features/SettingsPage/components/Orchestration"));
var DataStoringSetting_1 = require("@features/SettingsPage/components/DataStoringSetting");
var DeleteAllContent_1 = require("@features/SettingsPage/components/DeleteContent/DeleteAllContent");
var RightToBeForgotten_1 = require("@features/SettingsPage/components/DeleteContent/RightToBeForgotten");
var FieldEditing_1 = __importDefault(require("@features/SettingsPage/components/FieldEditing"));
var Security_1 = __importDefault(require("@features/SettingsPage/components/Security"));
var react_i18next_1 = require("react-i18next");
var MFASetting_1 = __importDefault(require("./components/MFASetting"));
function SettingsComponent(_a) {
    var component = _a.component, domain = _a.domain, siteNameChanged = _a.siteNameChanged, currentUserEmail = _a.currentUserEmail, currentTeamName = _a.currentTeamName, angularJsDependencies = _a.angularJsDependencies;
    switch (component) {
        case 'change-password':
            return react_1.default.createElement(PasswordSetting_1.default, null);
        case 'team-general':
            return react_1.default.createElement(TeamGeneralSetting_1.default, { domain: domain, siteNameChanged: siteNameChanged });
        case 'team-members':
            return react_1.default.createElement(TeamMembersSetting_1.default, { domain: domain, currentUserEmail: currentUserEmail });
        case 'manual-moderation-settings':
            return react_1.default.createElement(ModerationSetting_1.default, { domain: domain });
        case 'field-editing':
            return react_1.default.createElement(FieldEditing_1.default, { domain: domain });
        case 'orchestration':
            return react_1.default.createElement(Orchestration_1.default, { domain: domain });
        case 'api-integration':
            return react_1.default.createElement(ApiIntegration_1.default, { domain: domain, angularJsDependencies: angularJsDependencies });
        case 'right-to-be-forgotten':
            return react_1.default.createElement(RightToBeForgotten_1.RightToBeForgotten, { domain: domain });
        case 'data-storing-options':
            return react_1.default.createElement(DataStoringSetting_1.DataStroginOptions, { domain: domain });
        case 'delete-all-content':
            return react_1.default.createElement(DeleteAllContent_1.DeleteAllContent, { domain: domain, currentTeamName: currentTeamName, angularJsDependencies: angularJsDependencies });
        case 'security':
            return react_1.default.createElement(Security_1.default, { domain: domain });
        case 'mfa':
            return react_1.default.createElement(MFASetting_1.default, null);
        default:
            return react_1.default.createElement(TeamGeneralSetting_1.default, { domain: domain, siteNameChanged: siteNameChanged });
    }
}
exports.SettingsComponent = SettingsComponent;
var getPageTitle = function (component) {
    switch (component) {
        case 'change-password':
            return 'PAGE_TITLE.CHANGE_PASSWORD';
        case 'team-general':
            return 'PAGE_TITLE.GENERAL_SETTING';
        case 'team-members':
            return 'PAGE_TITLE.TEAM_MEMBERS';
        case 'manual-moderation-settings':
            return 'PAGE_TITLE.MODERATION_SETTING';
        case 'field-editing':
            return 'PAGE_TITLE.FIELD_EDITING';
        case 'orchestration':
            return 'PAGE_TITLE.ORCHESTRATION';
        case 'api-integration':
            return 'PAGE_TITLE.API_INTEGRATION';
        case 'security':
            return 'PAGE_TITLE.SECURITY';
        case 'right-to-be-forgotten':
            return 'PAGE_TITLE.DELETE_USER_DATA';
        case 'data-storing-options':
            return 'PAGE_TITLE.DATA_RETENTION_POLICY';
        case 'delete-all-content':
            return 'PAGE_TITLE.DELETE_ALL_CONTENT';
        case 'mfa':
            return 'PAGE_TITLE.MFA';
        default:
            return 'PAGE_TITLE.GENERAL_SETTING';
    }
};
function Settings(_a) {
    var component = _a.component, domain = _a.domain, angularJsDependencies = _a.angularJsDependencies, siteNameChanged = _a.siteNameChanged, currentUserEmail = _a.currentUserEmail, currentTeamName = _a.currentTeamName;
    var t = (0, react_i18next_1.useTranslation)().t;
    (0, react_1.useEffect)(function () {
        document.title = "".concat(t(getPageTitle(component)), " - Implio");
    }, [component]);
    return (react_1.default.createElement("div", { className: "settings container" },
        react_1.default.createElement("div", { className: "row" },
            react_1.default.createElement("div", { className: "col-xs-3" },
                react_1.default.createElement(LeftMenu_1.Sidebar, { angularJsDependencies: angularJsDependencies, domain: domain, currentComponent: component })),
            react_1.default.createElement(SettingsComponent, { component: component, domain: domain, siteNameChanged: siteNameChanged, currentUserEmail: currentUserEmail, currentTeamName: currentTeamName, angularJsDependencies: angularJsDependencies }))));
}
exports.Settings = Settings;
